import React from 'react';

import IconEdit from '@digital-hig/icon/icons/edit';
import SvgIcon from '@digital-hig/mui/SvgIcon';

interface CommentActionsProps {
  onEdit: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isAuthor?: boolean;
}

export default function CommentActionUI({
  onEdit,
  isAuthor,
}: CommentActionsProps) {
  const actions = [];

  if (isAuthor) {
    actions.push({
      title: 'Edit',
      icon: (
        <SvgIcon fontSize="large" className="au-h-4">
          <IconEdit />
        </SvgIcon>
      ),
      onClick: onEdit,
    });
  }

  return (
    <div className="au-flex au-justify-end au-absolute au-right-0 au-bottom-0 au-gap-c8 au-text-gray-600">
      {actions.map(({ icon, onClick, title }) => (
        <div key={title}>
          <button type="button" onClick={e => onClick(e)}>
            {icon}
          </button>
        </div>
      ))}
    </div>
  );
}
